export const container = {
  margin: '0 auto',
  maxWidth: '112.0rem',
  padding: '0 2.0rem',
  position: 'relative',
  width: '100%'
}

export const row = {
  display: 'flex',
  flexDirection: 'row',
  padding: 0,
  width: '100%'
}

export const column = {
  display: 'block',
  flex: '1 1 auto',
  marginLeft: 0,
  maxWidth: '100%',
  width: '100%'
}

export const column10 = {
  ...column,
  flex: '0 0 10%',
  maxWidth: '10%'
}

export const column20 = {
  ...column,
  flex: '0 0 20%',
  maxWidth: '20%'
}

export const column22 = {
  ...column,
  flex: '0 0 22%',
  maxWidth: '22%'
}

export const column25 = {
  ...column,
  flex: '0 0 25%',
  maxWidth: '25%'
}

export const column30 = {
  ...column,
  flex: '0 0 30%',
  maxWidth: '30%'
}

export const column33 = {
  ...column,
  flex: '0 0 33.3333%',
  maxWidth: '33.3333%'
}

export const column40 = {
  ...column,
  flex: '0 0 40%',
  maxWidth: '40%'
}

export const column45 = {
  ...column,
  flex: '0 0 45%',
  maxWidth: '45%'
}

export const column50 = {
  ...column,
  flex: '0 0 50%',
  maxWidth: '50%'
}

export const column60 = {
  ...column,
  flex: '0 0 60%',
  maxWidth: '60%'
}

export const column66 = {
  ...column,
  flex: '0 0 66%',
  maxWidth: '66%'
}

export const column75 = {
  ...column,
  flex: '0 0 75%',
  maxWidth: '75%'
}

export const column80 = {
  ...column,
  flex: '0 0 80%',
  maxWidth: '80%'
}

export const column90 = {
  ...column,
  flex: '0 0 90%',
  maxWidth: '90%'
}



// WEBPACK FOOTER //
// ./src/helpers/styles/grid.js